import { useQuery } from "@tanstack/react-query";
import { getSupabaseClient } from "../../providers/supabase/supabase";
import { useIsDueno } from "../useIsDueno";

/**
 * "En CRM" only for companies in the caller's own workspace. directory.company_id is shared (whoever promotes first
 * keeps the company), so for a freelancer a company promoted in ANOTHER workspace must look like a free one: the
 * promotion then fails with the same "no disponible" as an out-of-zone one. The owner keeps today's behavior.
 */
export const useInCrm = (rows: { company_id: number | null }[]) => {
  const isDueno = useIsDueno();
  const ids = rows
    .map((r) => r.company_id)
    .filter((id): id is number => id != null);
  const { data: own } = useQuery({
    queryKey: ["directory_own_companies", ids],
    enabled: !isDueno && ids.length > 0,
    queryFn: async () => {
      // RLS returns only the caller's own companies
      const { data, error } = await getSupabaseClient()
        .from("companies")
        .select("id")
        .in("id", ids);
      if (error) throw error;
      return new Set(data.map((c) => c.id as number));
    },
  });
  return (r: { company_id: number | null }) =>
    r.company_id != null && (isDueno || !!own?.has(r.company_id));
};
